import { dark, defaultTheme } from './themes'

export const themesMap = {
    default: defaultTheme,
    dark,
}

